<template>
  <el-dialog title="Мессеж загвар" v-model="createMessageDialog" width="50%">
    <el-row>
      <el-col class="mb-5">
        Гарчиг  <span class="red_color">*</span>
        <el-input v-model="formData.title"></el-input>
      </el-col>
      <el-col class="mb-5">
        Мессеж текст  <span class="red_color">*</span>
        <el-input type="textarea" v-model="formData.sms_text"></el-input>
      </el-col>
      <el-col>
        <el-button type="success" class=" w-100" @click="submitForm()">Хадгалах</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import services from '../services'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CreateMessageDialog',
  data () {
    return {
      formData: this.selectedMessage !== null
        ? this.selectedMessage
        : {
            title: '',
            sms_text: ''
          }
    }
  },
  props: {
    selectedMessage: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(['createMessageDialog'])
  },
  watch: {
    selectedMessage: {
      immediate: true, // Хэрэглэгчийн өгөгдөл анх ороход ажиллана
      handler (newValue) {
        this.formData = {
          ...newValue
        }
      }
    }
  },
  methods: {
    ...mapActions(['setCreateMessageDialog']),
    handleClose () {
      this.formData = {}
      this.setCreateMessageDialog(false)
    },
    async submitForm () {
      if (!this.formData.title) {
        this.$notify({
          title: 'Уучлаарай',
          message: 'Та мессежний гарчиг оруулна уу.',
          type: 'error',
          duration: 3000
        })
        return
      }
      if (!this.formData.sms_text) {
        this.$notify({
          title: 'Уучлаарай',
          message: 'Та мессеж илгээх текст оруулна уу.',
          type: 'error',
          duration: 3000
        })
        return
      }
      const payload = this.formData
      try {
        // const apiCall = services.get('sendSms', payload)
        // const apiCall = services.create('message', payload)
        const apiCall = this.formData.id
          ? services.update('message', payload)
          : services.create('message', payload)

        await apiCall
        this.$notify({
          title: 'Амжилттай',
          message: 'Мессеж загвар амжилттай үүслээ.',
          type: 'success'
        })
        this.$emit('refreshList')
        this.handleClose()
      } catch (error) {
        console.error('API Request Error:', error.message)
        this.$notify({
          title: 'Алдаа',
          message: error.message || 'Сүлжээний алдаа гарлаа.',
          type: 'error'
        })
      }
    }
  }
}

</script>

  <style scoped>
    .el-form {
      max-width: 600px;
      margin: 0 auto;
    }
    .red_color {
      color: red;
    }
  </style>
